export enum SupportRequestCategoryEnum {
  ACCOUNT_ACCESS = 'ACCOUNT_ACCESS',
  APP_USAGE = 'APP_USAGE',
  MARKETPLACE_PAYMENTS = 'MARKETPLACE_PAYMENTS',
  PRIVACY_DATA = 'PRIVACY_DATA',
  OTHER = 'OTHER',
}
